var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--dash",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6408 14.9029C22.0379 21.3315 15.5261 25.2438 9.096 23.6407C2.66861 22.0381 -1.24414 15.5265 0.359421 9.09837C1.96157 2.66903 8.47343 -1.24361 14.9015 0.359081C21.3311 1.96177 25.2438 8.47393 23.6408 14.9029Z",
    fill: "#008DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.522 5.24121H8.59684L8.10545 8.04974L13.4536 8.05622C16.088 8.05622 16.8647 9.03564 16.8426 10.6572C16.8299 11.4874 16.478 12.8949 16.3258 13.3522C15.92 14.5684 15.0863 15.9532 11.9604 15.9499L6.76128 15.9467L6.27148 18.7585H12.1839C14.2699 18.7585 15.1544 18.5087 16.096 18.0677C18.1788 17.0785 19.4184 14.977 19.9161 12.2333C20.6532 8.14703 19.7338 5.24121 14.522 5.24121Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04024 10.5894C4.48684 10.5894 4.26492 11.6239 4.11909 12.2498C3.92571 13.0671 3.8623 13.4011 3.8623 13.4011H9.93009C11.4835 13.4011 11.7054 12.3666 11.8512 11.7407C12.0446 10.9234 12.108 10.5894 12.108 10.5894H6.04024Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDash);
export default __webpack_public_path__ + "static/media/icon--dash.68e60b90fbe94a67f2fc5026293f8be0.svg";
export { ForwardRef as ReactComponent };